export const TABS = ['schedule', 'my agenda'];

export enum ViewType {
  CALENDAR = 'calendar',
  LIST = 'list',
}

export enum SCHEDULE_TAB {
  SCHEDULE = 'schedule',
  MY_AGENDA = 'my agenda',
}

export const VIEW_TYPE_KEY = 'viewTypeKey';
